export var DefaultSizeMap;
(function (DefaultSizeMap) {
    DefaultSizeMap["xl"] = "1440px";
    DefaultSizeMap["l"] = "1200px";
    DefaultSizeMap["md"] = "992px";
    DefaultSizeMap["sm"] = "744px";
    // sm = '576px',
})(DefaultSizeMap || (DefaultSizeMap = {}));
export var MagicCoeff = 3.8;
export var dwDescTop = [149.58, 149.47];
export var dhDescTop = [101.32, 197.37];
export var dwArr = {
    xsm: [72.60, 72.60],
    // xsm: [520 / 3.8, 320 / 3.8],
    sm: [101.10, 100.10],
    md: [118.15, 117.5],
    lg: dwDescTop,
    xl: dwDescTop,
    xxl: dwDescTop,
};
export var dhArr = {
    xsm: [50.0, 101.0],
    // xsm: [380 / 3.8, 456 / 3.8],
    sm: [66.84, 136.58],
    md: [80, 160],
    lg: [101.32, 197.37],
    xl: dhDescTop,
    xxl: dhDescTop,
};
//# sourceMappingURL=breakpoints.js.mapexport var DefaultSizeMap;
(function (DefaultSizeMap) {
    DefaultSizeMap["xl"] = "1440px";
    DefaultSizeMap["l"] = "1200px";
    DefaultSizeMap["md"] = "992px";
    DefaultSizeMap["sm"] = "744px";
    // sm = '576px',
})(DefaultSizeMap || (DefaultSizeMap = {}));
export var MagicCoeff = 3.8;
export var dwDescTop = [149.58, 149.47];
export var dhDescTop = [101.32, 197.37];
export var dwArr = {
    xsm: [72.60, 72.60],
    // xsm: [520 / 3.8, 320 / 3.8],
    sm: [101.10, 100.10],
    md: [118.15, 117.5],
    lg: dwDescTop,
    xl: dwDescTop,
    xxl: dwDescTop,
};
export var dhArr = {
    xsm: [50.0, 101.0],
    // xsm: [380 / 3.8, 456 / 3.8],
    sm: [66.84, 136.58],
    md: [80, 160],
    lg: [101.32, 197.37],
    xl: dhDescTop,
    xxl: dhDescTop,
};
//# sourceMappingURL=breakpoints.js.map